function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.81167 305.113C10.5701 346.647 34.909 359.415 54.5321 354.697C92.4805 345.573 186.84 344.894 273.004 402.886C387.123 479.694 428.456 402.91 403.993 313.104C379.529 223.298 381.401 137.353 435.455 99.7132C489.509 62.0731 442.973 -20.8181 323.213 34.6635C245.82 70.5177 197.501 50.5295 172.999 31.9016C149.908 14.3426 124.07 -4.32262 95.6208 1.34645C61.1004 8.2271 43.3499 33.6006 80.9809 104.437C134.307 204.819 -17.8199 212.018 1.81167 305.113Z",
  fill: "#DBDFFA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M229.064 295.471L232.281 299.286L231.314 329.081L100.679 355.253C99.7157 355.447 98.7231 355.45 97.7585 355.26C96.7939 355.07 95.8761 354.692 95.0576 354.148C94.239 353.603 93.5358 352.903 92.988 352.087C92.4403 351.27 92.0587 350.354 91.8652 349.39L53.6524 158.66C53.4573 157.697 53.4544 156.705 53.6439 155.741C53.8335 154.777 54.2117 153.859 54.7568 153.042C55.302 152.225 56.0033 151.523 56.8206 150.977C57.6378 150.432 58.5548 150.053 59.5188 149.863L198.663 121.967L192.573 143.186C192.573 143.186 203.709 164.186 205.864 167.594L195.625 211.878L225.867 241.825L216.277 280.233L229.064 295.471Z",
  fill: "url(#paint0_linear_608_9132)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M209.082 247.322L101.052 268.972C100.723 269.037 100.51 269.357 100.576 269.686L103.766 285.601C103.832 285.93 104.151 286.143 104.48 286.077L212.51 264.428C212.839 264.362 213.052 264.042 212.986 263.713L209.797 247.798C209.731 247.469 209.411 247.256 209.082 247.322Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M216.277 280.234L229.063 295.471L114.173 318.487C113.2 318.68 112.191 318.48 111.365 317.93C110.539 317.381 109.964 316.527 109.766 315.555L107.816 305.792C107.717 305.31 107.715 304.813 107.809 304.33C107.903 303.847 108.092 303.388 108.365 302.978C108.637 302.568 108.988 302.217 109.397 301.943C109.806 301.67 110.265 301.48 110.748 301.385L216.277 280.234Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M449.813 124.769L399.542 312.662C399.025 314.577 397.771 316.21 396.054 317.203C394.337 318.197 392.297 318.47 390.379 317.964L241.971 278.256L257.891 253.744L256.099 247.47L250.504 227.916L250.508 227.898L276.822 198.708L262.209 155.845L291.123 122.164L289.818 91.4421L305.921 78.5103L444.534 115.593C446.449 116.112 448.08 117.37 449.07 119.09C450.06 120.81 450.327 122.853 449.813 124.769V124.769Z",
  fill: "url(#paint1_linear_608_9132)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M417.115 127.634L390.108 120.407C383.631 118.674 376.976 122.52 375.243 128.996L368.016 156.003C366.283 162.48 370.128 169.135 376.605 170.868L403.612 178.095C410.089 179.828 416.744 175.983 418.477 169.506L425.704 142.5C427.437 136.023 423.592 129.367 417.115 127.634Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M281.017 239.945L278.455 249.566C278.196 250.523 277.569 251.34 276.71 251.837C275.852 252.333 274.831 252.47 273.872 252.217L256.099 247.469L250.504 227.915L278.383 235.368C278.858 235.493 279.303 235.711 279.693 236.01C280.083 236.308 280.41 236.681 280.655 237.107C280.9 237.532 281.058 238.002 281.12 238.489C281.182 238.976 281.147 239.471 281.017 239.945Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M223.175 110.318C222.467 109.546 222.086 108.53 222.113 107.484C222.139 106.437 222.57 105.441 223.315 104.706L250.838 76.4612C252.483 74.7741 255.154 74.734 256.716 76.3735L258.892 78.6586C260.453 80.2975 260.276 82.9568 258.502 84.5073L228.802 110.467C228.025 111.172 227.007 111.55 225.959 111.522C224.91 111.494 223.913 111.063 223.175 110.318V110.318Z",
  fill: "#0056D2"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M206.921 100.631C206.615 100.49 206.339 100.29 206.11 100.042C205.881 99.7942 205.703 99.5038 205.586 99.1873C205.47 98.8708 205.416 98.5344 205.43 98.1973C205.443 97.8602 205.523 97.529 205.664 97.2227L215.976 73.7075C216.265 73.0353 216.81 72.5053 217.489 72.2339C218.169 71.9626 218.928 71.9721 219.601 72.2604L221.499 73.1187C221.822 73.2685 222.111 73.4837 222.346 73.7507C222.582 74.0176 222.76 74.3306 222.869 74.6698C222.978 75.0091 223.015 75.3672 222.979 75.7216C222.942 76.076 222.833 76.4189 222.657 76.7288L210.448 99.3869C210.124 99.9995 209.581 100.468 208.928 100.698C208.274 100.929 207.558 100.905 206.921 100.631V100.631Z",
  fill: "#0056D2"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M189.803 104.439C187.64 104.82 185.563 102.979 185.096 100.268L176.796 52.1244C176.3 49.2484 177.8 46.5154 180.094 46.1121L183.293 45.5503C185.587 45.1473 187.754 47.2362 188.058 50.1456L193.159 98.8512C193.447 101.594 191.966 104.059 189.803 104.439Z",
  fill: "#0056D2"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_608_9132",
  x1: 142.892,
  y1: 121.967,
  x2: 142.892,
  y2: 355.401,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#397CDB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#699CFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_608_9132",
  x1: 346.02,
  y1: 78.5103,
  x2: 346.02,
  y2: 318.213,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0056D2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#669AFD"
})));

function SvgPaymentFail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 458,
    height: 435,
    viewBox: "0 0 458 435",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFail);
export default __webpack_public_path__ + "static/media/payment-fail.46599762.svg";
export { ForwardRef as ReactComponent };